if (!customElements.get('selling-plan-selector')) {
  customElements.define(
    'selling-plan-selector',
    class SellingPlanSelector extends HTMLElement {
      constructor() {
        super();

        this.options = this.querySelectorAll('.selling-plan-selector__option');
        this.radios = this.querySelectorAll('.selling-plan-selector__radio');
        this.sellingPlanInput = this.querySelector('.selling-plan-selector__input');
        this.frequencySelect = this.querySelector('.selling-plan-selector__select');

        this.bindEvents();
      }

      bindEvents() {
        this.options.forEach((option) => {
          option.addEventListener('click', (e) => {
            if (e.target.closest('.selling-plan-selector__select-wrap')) return;
            const radio = option.querySelector('.selling-plan-selector__radio');
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        this.radios.forEach((radio) => {
          radio.addEventListener('change', this.onOptionChange.bind(this));
        });

        if (this.frequencySelect) {
          this.frequencySelect.addEventListener('change', this.onFrequencyChange.bind(this));
        }
      }

      onOptionChange(e) {
        const value = e.target.value;

        this.options.forEach((opt) => {
          opt.classList.remove('selling-plan-selector__option--selected');
        });
        e.target
          .closest('.selling-plan-selector__option')
          .classList.add('selling-plan-selector__option--selected');

        if (value === 'subscribe' && this.sellingPlanInput) {
          const planId = this.frequencySelect ? this.frequencySelect.value : this.sellingPlanInput.dataset.defaultPlan;
          this.sellingPlanInput.value = planId;
          this.sellingPlanInput.disabled = false;
        } else if (this.sellingPlanInput) {
          this.sellingPlanInput.value = '';
          this.sellingPlanInput.disabled = true;
        }
      }

      onFrequencyChange(e) {
        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = e.target.value;
        }
      }
    }
  );
}

/* Buy Now button handler */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-form__buy-now').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const form = btn.closest('product-form')?.querySelector('form');
      if (!form) return;

      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');

      const formData = new FormData(form);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        });
    });
  });
});

/* Sticky mobile Add to Cart — always visible above the fold, proxies to main submit.
   Portal to <body> so it escapes `product__info-wrapper > div { z-index: 1 }`
   stacking contexts that otherwise let the description render in front of it.
   Mirrors the main submit's .loading / [disabled] state so tapping the sticky
   bar shows proper feedback. */
document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.querySelector('.sticky-atc');
  var mainSubmitBtn = document.querySelector('.product-form__submit');
  if (!stickyBar || !mainSubmitBtn) return;

  if (stickyBar.parentElement !== document.body) {
    document.body.appendChild(stickyBar);
  }

  var stickyBtn = stickyBar.querySelector('.sticky-atc__button');
  if (!stickyBtn) return;

  stickyBtn.addEventListener('click', function () {
    mainSubmitBtn.click();
  });

  var syncLoading = function () {
    stickyBtn.classList.toggle('loading', mainSubmitBtn.classList.contains('loading'));
    stickyBtn.disabled = mainSubmitBtn.disabled;
  };
  new MutationObserver(syncLoading).observe(mainSubmitBtn, {
    attributes: true,
    attributeFilter: ['class', 'disabled'],
  });
  syncLoading();
});
